export default __webpack_public_path__ + "static/media/balad.ebaad2fd.png";